/**
 * PowerSavingInfoContainer component.
 */
import Screen from '@shared/utils/screen';
import styled from 'styled-components';

/**
 * Styled power saving info container.
 */
const PowerSavingInfoContainer = styled.div<React.CSSProperties>`
  width: ${1120 * Screen.widthRatio}px;
`;

export default PowerSavingInfoContainer;
